import { Typography } from "@mui/material";

export const PriceDisplay = (props) => (
    <Typography style={props.style}>{formatCurrency(props.price, { ...props })}</Typography>
);

export const formatCurrency = (price, options) => {
    const {
        showUnit = true,
        currency = "zł",
        decimalPlaces = 2,
        perSquareMeter = false,
    } = options || {};

    if (price == null) {
        return "-";
    }

    const numericPrice = typeof price === "string" ? Number.parseFloat(price) : price;

    if (Number.isNaN(numericPrice)) {
        return "-";
    }

    const formattedPrice = numericPrice.toLocaleString("pl-PL", {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
    const unit = `${currency}${perSquareMeter ? "/m²" : ""}`;

    return showUnit ? `${formattedPrice} ${unit}` : formattedPrice;
};
